import { createSlice } from "@reduxjs/toolkit";

const reducerSlice = createSlice({
  name: "orders",
  initialState: {
    page: "ALL_ORDER",    
  },
  reducers: {
    setPage: (state, action) => {
      state.page = action.payload;
    },
  },
});

export const { setPage } = reducerSlice.actions;
export default reducerSlice;
